import Keyb from "keyb"
import Joyp from "joyp"
import Pointer from "poin"
import Screenfull from "screenfull"

import Game from "@frog/source/models/Game.js"
import Sequence from "@frog/source/models/Sequence.js"

import Navigation from "@frog/source/engine/navigating/Navigation.js"
import SequenceAnimation from "@frog/source/engine/animating/SequenceAnimation.js"
import Dev from "@frog/source/models/dev/Dev.js"

import navigation from "@frog/source/data/navigation.js" // eslint-disable-line no-unused-vars
import app from "@frog/source/data/app.js"

export default new class App {
    constructor() {
        window.frog = window.frog || {}
        window.frog.app = this

        this.defaultGameSlug = app.defaultGameSlug

        this.options = {}
    }
    update(delta) {
        if(Keyb.isPressed("<control>")
        && Keyb.isPressed("Q")) {
            Navigation.go("/title")
        }

        if(Keyb.isPressed("<shift>")
        && Keyb.wasJustPressed("F")) {
            Screenfull.toggle()
        }

        // if(Dev.isEnabled) {
        //     if(Keyb.wasJustPressed("1")) {
        //         this.options.disableActionUI = !this.options.disableActionUI
        //         console.log("action cursor", this.options.disableActionUI ? "disabled" : "enabled")
        //     }
        //     if(Keyb.wasJustPressed("2")) {
        //         this.options.disableHUD = !this.options.disableHUD
        //         console.log("hud", this.options.disableHUD ? "disabled" : "enabled")
        //     }
        //     if(Keyb.wasJustPressed("3")) {
        //         this.options.disableParticles = !this.options.disableParticles
        //         console.log("particles", this.options.disableParticles ? "disabled" : "enabled")
        //     }
        //
        //     if(Keyb.wasJustPressed("4")) {
        //         if(Audiomix.userMusicVolume > 0) {
        //             Audiomix.userMusicVolume = 0
        //             Audiomix.userAmbienceVolume = 0
        //             console.log("music disabled")
        //         } else {
        //             Audiomix.userMusicVolume = 1
        //             Audiomix.userAmbienceVolume = 1
        //             console.log("music enabled")
        //         }
        //     }
        // }

        if(Navigation.state != undefined) {
            if(Navigation.state.screen == "ChapterScreen") {
                if(Dev.inProtoMode == true) {
                    Navigation.state.escape = undefined
                }
                if(Dev.inProtoMode == false
                && Keyb.wasJustPressed("<escape>", delta.ms)) {
                    if(Navigation.state.escape == undefined) {
                        Navigation.state.escape = {"section": "MainSection"}
                    } else if(Navigation.state.escape != undefined) {
                        if(Navigation.state.escape.section == "MainSection") {
                            Navigation.state.escape = undefined
                        } else if(Navigation.state.escape.section == "OptionsSection") {
                            Navigation.state.escape.section = "MainSection"
                        }
                    }
                }

                if(Navigation.state.escape != undefined) {
                    return // paused!!
                }
            }
        }

        if(this.game != undefined) {
            Game.update(this.game, delta)
        }
        if(this.previewChapter != undefined) {
            // this.previewChapter.update(delta)

            const SLOWDOWN = 0.66
            SequenceAnimation.updateSequence({
                "sequence": this.previewChapter.sequence,
                "delta": {
                    "ms": delta.ms * SLOWDOWN,
                    "f": delta.f * SLOWDOWN,
                    "s": delta.s * SLOWDOWN,
                },
                "isMuted": true,
            })
        }

        if(Dev.inProtoMode != true
        && this.sequence != undefined) {
            SequenceAnimation.updateSequence({
                "sequence": this.sequence,
                "delta": delta,
            })

            if(Pointer.wasJustPressed("primary", true, delta.ms)
            || Keyb.wasJustPressed("<space>", delta.ms)
            || Joyp.wasJustPressed(0, "south-button", delta.ms)) {
                Sequence.seek(this.sequence)
            }
        }
    }
    load(app) {
        this.game = Game.load(app.game)
    }
    getActiveStage() {
        if(this.game != undefined
        && this.sequence != undefined
        && this.sequence.steps != undefined
        && this.sequence.steps[0] != undefined
        && this.sequence.steps[0].stage != undefined) {
            return this.sequence.steps[0].stage
        }
        if(this.game != undefined
        && this.sequence != undefined
        && this.sequence.steps != undefined
        && this.sequence.steps[0] != undefined
        && this.sequence.steps[0].omegastage != undefined) {
            return this.sequence.steps[0].omegastage
        }
        if(this.game != undefined
        && this.game.chapter != undefined) {
            return this.game.chapter.stage
        }
    }
}
